import { useMediaQuery } from "react-responsive";

function isDesktop() {
  return useMediaQuery({
    query: "(min-width: 1024px)",
  });
}

export { isDesktop };
